import React, { memo, useCallback, forwardRef } from 'react';
import PlatformSpecificDatePicker from './date_picker__';
import DateUtils from './date_time_utils';
import Navigation from '../../navigation';
import DropDown from './form/dropdown';
import { __WEB__ } from '../../constants/styles';
import moment from 'moment';

const DatePicker = memo(
  forwardRef((props, ref) => {
    const onDate = useCallback(
      (date) => {
        if (!date) {
          props.onDate?.(null);
          return;
        }
        const mode = props.mode || 'date';
        const sanitizedDate = mode === 'date' ? moment(date).startOf('day').toDate() : date;
        props.onDate?.(sanitizedDate);
      },
      [props.onDate, props.mode]
    );

    const openModal = useCallback(() => {
      Navigation.showModal({
        screen: 'DateTimeModal',
        title: props.label,
        passProps: {
          selectedDate: props.selectedDate,
          onDate: props.onDate,
          mode: props.mode,
          minDate: props.minDate,
          maxDate: props.maxDate,
          clearable: props.clearable,
          validateFunc: props.validateFunc,
          invalidText: props.invalidText,
          label: props.label,
          onDate,
        },
        options: {
          // width: 550
          // noNavBar: true
        },
      });
    }, [
      props.label,
      onDate,
      props.selectedDate,
      props.mode,
      props.minDate,
      props.maxDate,
      props.clearable,
      props.validateFunc,
      props.invalidText,
    ]);

    if (props.disabled || (!__WEB__ && props.nativeModal) || (!!__WEB__ && props.webModal)) {
      console.info('>>>> just returning a dropdown for ', props.label);
      return (
        <DropDown
          ref={ref}
          required={props.required}
          disabled={props.disabled}
          label={props.label}
          extraLabel={props.extraLabel}
          tipText={props.tipText}
          value={DateUtils.formatDateString(props.selectedDate)}
          imageSource={require('../../../resources/nav-icon-calendar.png')}
          onPress={openModal}
          flexibleHeight={props.flexibleHeight}
          containerStyle={props.containerStyle}
          validateFunc={props.validateFunc}
          invalidText={props.invalidText}
          placeholder={props.placeholder}
        />
      );
    }
    return <PlatformSpecificDatePicker ref={ref} {...props} onDate={onDate} />;
  })
);

export default DatePicker;
DatePicker.displayName = 'DatePicker';
